import React from "react";
import error from "../assets/404Thumbnail1.png";
const NotFound = () => {
  return (
    <div className="bodyFullHeight">
      <img className="error-thumbnail" src={error} alt="" />
    </div>
  );
};

export default NotFound;
